let memoryToken = null;

function safeGet(storage, key) {
  try { return storage?.getItem(key) || null; } catch { return null; }
}

function safeSet(storage, key, value) {
  try {
    storage?.setItem(key, value);
    return storage?.getItem(key) === value;
  } catch {
    return false;
  }
}

function safeRemove(storage, key) {
  try { storage?.removeItem(key); } catch {}
}

export function getAuthToken() {
  if (memoryToken) return memoryToken;
  const local = typeof window !== "undefined" ? safeGet(window.localStorage, "fc_token") : null;
  if (local) { memoryToken = local; return local; }
  const session = typeof window !== "undefined" ? safeGet(window.sessionStorage, "fc_token") : null;
  if (session) { memoryToken = session; return session; }
  return null;
}

export function setAuthToken(token) {
  memoryToken = token || null;
  if (!token || typeof window === "undefined") return;
  if (safeSet(window.localStorage, "fc_token", token)) {
    safeRemove(window.sessionStorage, "fc_token");
    return;
  }
  safeSet(window.sessionStorage, "fc_token", token);
}

export function clearAuthToken() {
  memoryToken = null;
  if (typeof window === "undefined") return;
  safeRemove(window.localStorage, "fc_token");
  safeRemove(window.sessionStorage, "fc_token");
}
